<template>
  <div class="page">
    <div class="main-content">
      <vue-headful
        title="EVAPAPA | Portfolio"
        description="Evangeline Papanicola's web development portfolio."
      />
      <Nav />
      <MobileNav />
      <div style="margin-bottom:20px;" class="full-width-container">
        <h1 class="hide-mobile">WEB DEVELOPMENT PORTFOLIO</h1>
        <h1 class="hide-desktop hide-tablet">PORTFOLIO</h1>
      </div>
      <div class="portfolio-grid-3" style="margin-bottom: 20px;">
        <div class="portfolio-item">
          <a href="https://suzydesign.co.uk/#/"
            ><div class="pimg">
              <img alt="Suzy Design" src="../assets/suzythumb.png" /></div
          ></a>
          <a href="https://suzydesign.co.uk/#/"
            ><div class="ptitle">Suzy Design</div></a
          >
          <div class="pdesc">
            For my University final year project, I took on a client-based
            project to create a website for Suzy Design that would showcase her
            work as a graphic designer. Developed using
            <span class="highlight">Vue.js</span>.
          </div>
        </div>
        <div class="portfolio-item">
          <a href="https://bakery-future-tech.netlify.app/"
            ><div class="pimg">
              <img alt="Bakery Website" src="../assets/bakerythumb.png" /></div
          ></a>
          <a href="https://bakery-future-tech.netlify.app/"
            ><div class="ptitle">Bakery</div></a
          >
          <div class="pdesc">
            A sample <span class="highlight">Gatsby</span> site for a made-up
            bakery business. Created for the Future Technologies unit of my
            final year of University.
          </div>
        </div>
        <div class="portfolio-item">
          <a href="https://crafty.netlify.app/"
            ><div class="pimg">
              <img alt="Crafty Website" src="../assets/craftythumb.png" /></div
          ></a>
          <a href="https://crafty.netlify.app/"
            ><div class="ptitle">Crafty</div></a
          >
          <div class="pdesc">
            A website created during my second year of University. The website
            was designed mostly using pure
            <span class="highlight">HTML5</span>,
            <span class="highlight">CSS3</span>,
            <span class="highlight">JavaScript</span> and
            <span class="highlight">Bootstrap</span>. The goal of the unit was
            to create a website designed for displaying videos - so I chose to
            make a website for arts & crafts lovers.
          </div>
        </div>
      </div>
      <div class="portfolio-grid-2">
        <div class="portfolio-item">
          <a href="https://arthur-conan.netlify.app/"
            ><div class="pimg">
              <img
                alt="Arthur Conan App"
                src="../assets/arthurthumb.png"
              /></div
          ></a>
          <a href="https://arthur-conan.netlify.app/"
            ><div class="ptitle">The Life of Arthur Conan-Doyle</div></a
          >
          <div class="pdesc">
            A location based <span class="highlight">Progressive Web App</span>,
            made using <span class="highlight">React</span> created for the
            Arthur Conan-Doyle Collection in Portsmouth Central Library. I
            worked within a team to develop an app that would allow users to
            find historical landmarks relating to Conan-Doyle.
          </div>
        </div>
        <div class="portfolio-item">
          <a href="https://evangelinepapanicola.itch.io/nox-caelo"
            ><div class="pimg">
              <img
                alt="Nox Caelo Game"
                src="../assets/noxcaelothumb.png"
              /></div
          ></a>
          <a href="https://evangelinepapanicola.itch.io/nox-caelo"
            ><div class="ptitle">Nox Caelo</div></a
          >
          <div class="pdesc">
            A basic text-adventure game I developed in my free time, using
            <span class="highlight">Vue.js</span> and Inkle's
            <span class="highlight">Ink</span> scripting language.
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Nav from "@/components/Nav.vue";
import MobileNav from "@/components/MobileNav.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",
  components: {
    Nav,
    MobileNav,
    Footer
  }
};
</script>
